import React, { useEffect, useState } from "react";
import { config } from "../../config";
import "../Shopkeeper/css/demo.css";
import "../Shopkeeper/css/ready.css";
import { Link, useNavigate } from "react-router-dom";
import { Button, Modal, Table } from "react-bootstrap";
import { TableBody, TableRow } from "@mui/material";
import {
  ExclamationTriangleFill,
  QuestionCircleFill,
} from "react-bootstrap-icons";
import { BsQuestionOctagon } from "react-icons/bs";

export default function Home() {
  const [promotions, setPromotions] = useState([]);
  const [allPromotions, setAllPromotions] = useState([]);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1); // page number starts at 1

  const itemsPerPage = 10;
  const totalElements = allPromotions.totalElements;

  const totalPages = Math.ceil(totalElements / itemsPerPage);

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const generatePageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  const fetchAllData = async () => {
    const access_token = localStorage.getItem("accessToken");
    const locationId = localStorage.getItem("locationId");
    const userId = localStorage.getItem("userId");

    const url = `${config.api_base}api/v2/bcf11870-f401-427e-b940-1758c5a79540/shop/${userId}/promotion?page=0&offset=100&type=ALL`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch promotions");
      }

      const data = await response.json();
      console.log("Promotions:", data);
      setAllPromotions(data);
    } catch (err) {
      console.error("Error fetching promotions:", err);
      setError(err.message);
    }
  };

  const fetchShopPromotions = async (page = 1) => {
    const access_token = localStorage.getItem("accessToken");
    const locationId = localStorage.getItem("locationId");
    const userId = localStorage.getItem("userId");

    const offset = 10;
    const url = `${
      config.api_base
    }api/v2/bcf11870-f401-427e-b940-1758c5a79540/shop/${userId}/promotion?page=${
      page - 1
    }&offset=${offset}&type=ALL`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch promotions");
      }

      const data = await response.json();
      console.log("Promotions:", data);
      setPromotions(data);
    } catch (err) {
      console.error("Error fetching promotions:", err);
      setError(err.message);
    }
  };

  useEffect(() => {
    fetchAllData();
    fetchShopPromotions(currentPage);
  }, [currentPage]);

  // active data
  const [activePromotions, setActivePromotions] = useState([]);
  const totalActiveElements = activePromotions.totalElements;

  const totalActivePages = Math.ceil(totalActiveElements / itemsPerPage);

  const handleActivePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleActiveNextPage = () => {
    if (currentPage < totalActivePages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const generateActivePageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalActivePages; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  const activeData = async (page = 1) => {
    const access_token = localStorage.getItem("accessToken");
    const locationId = localStorage.getItem("locationId");
    const userId = localStorage.getItem("userId");

    const offset = 10;
    const url = `${config.api_base}api/v2/shop_promotion/promotion_by_status/OPEN?page=${page}&offset=${offset}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch promotions");
      }

      const data = await response.json();
      console.log("ActivePromotions:", data);
      setActivePromotions(data);
    } catch (err) {
      console.error("Error fetching promotions:", err);
      setError(err.message);
    }
  };

  // expiry

  const [expiryPromotions, setExpiryPromotions] = useState([]);
  const totalExpiryElements = expiryPromotions.totalElements;

  const totalExpiryPages = Math.ceil(totalExpiryElements / itemsPerPage);

  const handleExpiryPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleExpiryNextPage = () => {
    if (currentPage < totalExpiryPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const generateExpiryPageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalExpiryPages; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  const expiryData = async (page = 1) => {
    const access_token = localStorage.getItem("accessToken");
    const locationId = localStorage.getItem("locationId");
    const userId = localStorage.getItem("userId");

    const offset = 10;
    const url = `${config.api_base}api/v2/shop_promotion/promotion_by_status/EXPIRY?page=${page}&offset=${offset}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch promotions");
      }

      const data = await response.json();
      console.log("ExpiryPromotions:", data);
      setExpiryPromotions(data);
    } catch (err) {
      console.error("Error fetching promotions:", err);
      setError(err.message);
    }
  };

  // deleted
  const [deletedPromotions, setDeletedPromotions] = useState([]);

  const totalDeleteElements = deletedPromotions.totalElements;

  const totalDeletePages = Math.ceil(totalDeleteElements / itemsPerPage);

  const handleDeletePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleDeleteNextPage = () => {
    if (currentPage < totalDeletePages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const generateDeletePageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalDeletePages; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  const deletedData = async (page = 1) => {
    const access_token = localStorage.getItem("accessToken");
    const locationId = localStorage.getItem("locationId");
    const userId = localStorage.getItem("userId");

    const offset = 10;
    const url = `${config.api_base}api/v2/shop_promotion/promotion_by_status/DELETED?page=${page}&offset=${offset}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch promotions");
      }

      const data = await response.json();
      console.log("ExpiryPromotions:", data);
      setDeletedPromotions(data);
    } catch (err) {
      console.error("Error fetching promotions:", err);
      setError(err.message);
    }
  };

  const navigate = useNavigate();

  const handleLogout = (e) => {
    // e.preventDefault();

    // const confirmLogout = window.confirm("Are you sure you want to logout?");
    // if (confirmLogout) {
    localStorage.clear();
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userId"); // Clear localStorage
    navigate("/"); // Navigate to home route
    // }
  };

  const [showModal, setShowModal] = useState(false);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const confirmLogout = () => {
    handleLogout();
    handleClose();
  };

  const totalViews = (allPromotions.promotions || []).reduce(
    (sum, promo) => sum + promo.views,
    0
  );

  const totalLikes = (allPromotions.promotions || []).reduce(
    (sum, promo) => sum + promo.likes,
    0
  );

  const deleteShopPromotion = async (promotionId) => {
    const access_token = localStorage.getItem("accessToken");
    const userId = localStorage.getItem("userId");

    const url = `${config.api_base}api/v2/bcf11870-f401-427e-b940-1758c5a79540/shop/${userId}/promotion/${promotionId}`;

    const confirmed = window.confirm(
      "Are you sure you want to delete this promotion?"
    );
    if (!confirmed) return;

    try {
      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to delete promotion");
      }

      console.log("Promotion deleted successfully");
      // Optionally re-fetch promotions
      fetchShopPromotions();
    } catch (err) {
      console.error("Error deleting promotion:", err);
      setError(err.message);
    }
  };

  return (
    <>
      <div className="wrapper">
        <div className="main-header">
          <div className="logo-header text-center">
            <a href="https://adoop.in/" target="_blank">
              <img
                src="assets/img/logo/adoop-png.png"
                style={{ width: "100px" }}
                alt="logo"
              />
            </a>
            <button
              className="navbar-toggler sidenav-toggler ml-auto"
              type="button"
              data-toggle="collapse"
              data-target="collapse"
              aria-controls="sidebar"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <button className="topbar-toggler more">
              <i className="la la-ellipsis-v"></i>
            </button>
          </div>
          <nav className="navbar navbar-header navbar-expand-lg">
            <div className="container-fluid">
              <form
                className="navbar-left navbar-form nav-search mr-md-3"
                action=""
              >
                {/* <div className="input-group">
                  <input
                    type="text"
                    placeholder="Search ..."
                    className="form-control"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">
                      <i className="fas fa-search"></i>
                    </span>
                  </div>
                </div> */}
              </form>
              <ul className="navbar-nav topbar-nav ml-md-auto align-items-center">
                <li className="nav-item dropdown">
                  <a
                    className="profile-pic"
                    href="#"
                    aria-expanded="false"
                    style={{ textDecoration: "none" }}
                  >
                    <img
                      src={`https://d3p6cw3ny59ckg.cloudfront.net/store/${promotions.shop?.logo}`}
                      alt="user-img"
                      width="36"
                      className="img-circle"
                    />
                    <span>Hello, {promotions?.shop?.name || "Shopkeeper"}</span>{" "}
                  </a>
                  <ul className="dropdown-menu dropdown-user">
                    <li>
                      <div className="user-box">
                        <div className="u-img">
                          <img src="assets/img/profile.jpg" alt="user" />
                        </div>
                        <div className="u-text">
                          <h4> {promotions?.shop?.name || "Shopkeeper"}</h4>
                          <p className="text-muted">kktannu60@.com</p>
                          <a
                            href="profile.html"
                            className="btn btn-rounded btn-danger btn-sm"
                          >
                            View Profile
                          </a>
                        </div>
                      </div>
                    </li>
                    <div className="dropdown-divider"></div>
                    <a className="dropdown-item" href="#">
                      <i className="ti-user"></i> My Profile
                    </a>
                    <a className="dropdown-item" href="#">
                      {" "}
                      My Balance
                    </a>
                    <a className="dropdown-item" href="#">
                      <i className="ti-email"></i> Inbox
                    </a>
                    <div className="dropdown-divider"></div>

                    <a className="dropdown-item" href="#">
                      <i className="fa fa-power-off"></i> Logout
                    </a>
                  </ul>
                  {/* <!-- /.dropdown-user --> */}
                </li>
              </ul>
            </div>
          </nav>
        </div>
        <div className="sidebar">
          <div className="scrollbar-inner sidebar-wrapper">
            <ul className="nav">
              <li className="nav-item active">
                <Link to="/shophome" style={{ textDecoration: "none" }}>
                  <i class="fa-solid fa-house"></i>
                  <p>Home</p>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/addpromotions" style={{ textDecoration: "none" }}>
                  <i class="bi bi-megaphone-fill"></i>
                  <p>Promo</p>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/shopProfile" style={{ textDecoration: "none" }}>
                  <i class="bi bi-person-fill"></i>
                  <p>Profile</p>
                </Link>
              </li>
                <li className="nav-item">
                <Link to="/shopPricing" style={{ textDecoration: "none" }}>
                  <i class="bi bi-cash"></i>
                  <p>My Subscription</p>
                </Link>
              </li>
              <li className="nav-item">
                {/* <Link
                  to=""
                  style={{ textDecoration: "none" }}
                  onClick={handleLogout}
                  
                >
                  <i class="fa-solid fa-right-from-bracket"></i>
                  <p>Logout</p>
                </Link> */}

                <Link
                  to="#"
                  onClick={handleShow}
                  style={{ textDecoration: "none" }}
                >
                  <i className="fa-solid fa-right-from-bracket"></i>
                  <p>Logout</p>
                </Link>

                {/* React Bootstrap Modal */}
                <Modal
                  show={showModal}
                  onHide={handleClose}
                  size="sm"
                  // centered
                  dialogClassName="custom-logout-modal"
                >
                  <Modal.Header closeButton className="modal-header-warning">
                    <Modal.Title style={{ fontSize: "18px", color: "#fff" }}>
                      Sign Out
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body className="d-flex align-items-center gap-2">
                    <BsQuestionOctagon size={20} className="text-dark" />
                    <span>Do you really want to sign out?</span>
                  </Modal.Body>
                  <Modal.Footer className="justify-content-end">
                    <Button
                      variant="outline-secondary"
                      className="btn-no"
                      onClick={handleClose}
                    >
                      No
                    </Button>
                    <Button
                      variant="light" // prevents default "primary" background
                      className="btn-yes ms-2"
                      style={{
                        backgroundColor: "#ffc600",
                        border: "none",
                        color: "black",
                      }}
                      onClick={confirmLogout}
                    >
                      Yes
                    </Button>
                  </Modal.Footer>
                </Modal>
              </li>

              
            </ul>
          </div>
        </div>
        <div className="main-panel">
          <div className="content">
            <div className="container-fluid bg-white p-3 rounded mb-4">
              <h4 className="page-title">Shopkeeper Dashboard</h4>
              {allPromotions && (
                <div className="row">
                  <div className="col-md-4">
                    <div
                      className="card card-stats card-warning"
                      style={{ background: "#FFC600" }}
                    >
                      <div className="card-body ">
                        <div className="row">
                          <div className="col-5">
                            <div className="icon-big text-center">
                              <i class="bi bi-megaphone-fill"></i>
                            </div>
                          </div>
                          <div className="col-7 d-flex align-items-center">
                            <div className="numbers">
                              <p className="card-category">Promos</p>
                              <h4 className="card-title">
                                {allPromotions.totalElements}
                              </h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div
                      className="card card-stats card-warning"
                      style={{ background: "#FFC600" }}
                    >
                      <div className="card-body ">
                        <div className="row">
                          <div className="col-5">
                            <div className="icon-big text-center">
                              <i class="bi bi-eye-fill"></i>
                            </div>
                          </div>
                          <div className="col-7 d-flex align-items-center">
                            <div className="numbers">
                              <p className="card-category">Views</p>
                              <h4 className="card-title">
                                {totalViews.toLocaleString()}
                              </h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div
                      className="card card-stats card-warning"
                      style={{ background: "#FFC600" }}
                    >
                      <div className="card-body">
                        <div className="row">
                          <div className="col-5">
                            <div className="icon-big text-center">
                              <i class="bi bi-suit-heart-fill"></i>
                            </div>
                          </div>
                          <div className="col-7 d-flex align-items-center">
                            <div className="numbers">
                              <p className="card-category">Likes</p>
                              <h4 className="card-title">
                                {totalLikes.toLocaleString()}
                              </h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {promotions && (
              <div class="container-fluid bg-white p-3 rounded">
                <div class="row ">
                  <div class="col-lg-6 col-md-6">
                    <h4 class="page-title">My Ads</h4>
                  </div>

                  <div class="col-lg-6 col-md-6">
                    <ul
                      class="nav nav-pills mb-3 border-2"
                      id="pills-tab"
                      role="tablist"
                    >
                      <li class="nav-item" role="presentation">
                        <button
                          class="nav-link active position-relative"
                          id="pills-all-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-all"
                          type="button"
                          role="tab"
                          aria-controls="pills-all"
                          aria-selected="true"
                        >
                          All
                        </button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button
                          class="nav-link position-relative"
                          id="pills-active-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-active"
                          type="button"
                          role="tab"
                          aria-controls="pills-active"
                          aria-selected="false"
                          onClick={() => activeData(0)}
                        >
                          Active
                        </button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button
                          class="nav-link position-relative"
                          id="pills-expiry-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-expiry"
                          type="button"
                          role="tab"
                          aria-controls="pills-expiry"
                          aria-selected="false"
                          onClick={() => expiryData(0)}
                        >
                          Expiry
                        </button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button
                          class="nav-link position-relative"
                          id="pills-deleted-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-deleted"
                          type="button"
                          role="tab"
                          aria-controls="pills-deleted"
                          aria-selected="false"
                          onClick={() => deletedData(0)}
                        >
                          Deleted
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* tabs content */}

                <div class="tab-content" id="pills-tabContent">
                  <div
                    class="tab-pane fade show active"
                    id="pills-all"
                    role="tabpanel"
                    aria-labelledby="pills-all-tab"
                  >
                    <div class="row row-cols-1 row-cols-md-2  gx-4">
                      {Array.isArray(promotions.promotions) &&
                      promotions.promotions.length > 0 ? (
                        promotions.promotions.map((promo) => (
                          <div class="col-sm-6 ">
                            <div class="card card-border-yellow">
                              <div class="row g-0">
                                <div
                                  className="col-md-6 d-flex align-items-center justify-content-center border-right-home"
                                  style={{
                                    maxHeight: "420px",
                                    overflow: "hidden",
                                  }}
                                >
                                  <img
                                    src={`https://d3p6cw3ny59ckg.cloudfront.net/store/${
                                      promo.image || "default.jpg"
                                    }`}
                                    alt="Promo"
                                    style={{
                                      maxWidth: "100%",
                                      maxHeight: "100%",
                                      objectFit: "contain",
                                    }}
                                  />
                                </div>

                                <div class="col-md-6">
                                  <div class="card-body overflow-auto">
                                    <p
                                      class="card-text"
                                      // style={{ textAlign: "justify" }}
                                    >
                                      {promo.promotion_attributes
                                        ?.description ||
                                        "No details available."}
                                    </p>
                                  </div>
                                  <div class="col-12 p-3">
                                    <div className="mb-0">
                                      <Table class="table table-borderless mb-0">
                                        <TableBody>
                                          <TableRow>
                                            <td class="text-bold">Likes:</td>
                                            <td>{promo.likes}</td>
                                          </TableRow>
                                          <TableRow>
                                            <td class="text-bold">Views:</td>
                                            <td>{promo.views}</td>
                                          </TableRow>
                                          <TableRow>
                                            <td class="text-bold">Status:</td>
                                            <td>
                                              {promo.status
                                                .charAt(0)
                                                .toUpperCase() +
                                                promo.status
                                                  .slice(1)
                                                  .toLowerCase()}
                                            </td>
                                          </TableRow>
                                        </TableBody>
                                      </Table>
                                      <Link
                                        href="#"
                                        className={`btn btn-outline-danger mt-0 ${
                                          promo.status === "DELETED" ||
                                          promo.status === "EXPIRED"
                                            ? "disabled"
                                            : ""
                                        }`}
                                        style={{
                                          width: "100%",
                                          pointerEvents:
                                            promo.status === "DELETED" ||
                                            promo.status === "EXPIRED"
                                              ? "none"
                                              : "auto",
                                          opacity:
                                            promo.status === "DELETED" ||
                                            promo.status === "EXPIRED"
                                              ? 0.5
                                              : 1,
                                        }}
                                        onClick={(e) => {
                                          if (
                                            promo.status !== "DELETED" &&
                                            promo.status !== "EXPIRED"
                                          ) {
                                            deleteShopPromotion(promo.id);
                                          } else {
                                            e.preventDefault();
                                          }
                                        }}
                                      >
                                        <i className="fas fa-trash"></i> Delete
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div class="col-12 text-center py-3">
                          <img
                            src="assets/img/data-not-found-png-yellow.jpg.png"
                            class="img-fluid rounded-start"
                            alt="..."
                          />
                          <h4>No deleted data available.</h4>
                        </div>
                      )}

                      {/* pagination */}
                      <div className="col-12 d-flex align-items-center justify-content-center">
                        <ul className="pagination">
                          <li
                            className={`page-item ${
                              currentPage === 1 ? "disabled" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={handlePreviousPage}
                            >
                              &laquo;
                            </button>
                          </li>
                          {generatePageNumbers().map((page) => (
                            <li
                              key={page}
                              className={`page-item ${
                                currentPage === page ? "active" : ""
                              }`}
                            >
                              <button
                                className="page-link"
                                onClick={() => setCurrentPage(page)}
                              >
                                {page}
                              </button>
                            </li>
                          ))}
                          <li
                            className={`page-item ${
                              currentPage === totalPages ? "disabled" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={handleNextPage}
                            >
                              &raquo;
                            </button>
                          </li>
                        </ul>
                      </div>
                      {/* end pagination */}
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="pills-active"
                    role="tabpanel"
                    aria-labelledby="pills-active-tab"
                  >
                    <div className="row row-cols-1 row-cols-md-2 gx-4">
                      {Array.isArray(activePromotions.data) &&
                      activePromotions.data.length > 0 ? (
                        activePromotions.data.map((promo) => (
                          <div className="col-sm-6" key={promo.id}>
                            <div className="card card-border-yellow">
                              <div className="row g-0">
                                <div
                                  className="col-md-6 d-flex align-items-center justify-content-center border-right-home"
                                  style={{
                                    maxHeight: "420px",
                                    overflow: "hidden",
                                  }}
                                >
                                  <img
                                    src={`https://d3p6cw3ny59ckg.cloudfront.net/store/${
                                      promo.image || "default.jpg"
                                    }`}
                                    alt="Promo"
                                    style={{
                                      maxWidth: "100%",
                                      maxHeight: "100%",
                                      objectFit: "contain",
                                    }}
                                  />
                                </div>

                                <div className="col-md-6">
                                  <div className="card-body overflow-auto">
                                    <p className="card-text">
                                      {promo.promotion_attributes
                                        ?.description ||
                                        "No details available."}
                                    </p>
                                  </div>
                                  <div class="col-12 p-3">
                                    <div className="mb-0">
                                      <Table class="table table-borderless mb-0">
                                        <TableBody>
                                          <TableRow>
                                            <td class="text-bold">Likes:</td>
                                            <td>{promo.likes}</td>
                                          </TableRow>
                                          <TableRow>
                                            <td class="text-bold">Views:</td>
                                            <td>{promo.views}</td>
                                          </TableRow>
                                          <TableRow>
                                            <td class="text-bold">Status:</td>
                                            <td>
                                              Active
                                              {/* {promo.promotionStatus
                                                ? promo.promotionStatus
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                  promo.promotionStatus
                                                    .slice(1)
                                                    .toLowerCase()
                                                : "N/A"} */}
                                            </td>
                                          </TableRow>
                                        </TableBody>
                                      </Table>
                                      <Link
                                        href="#"
                                        className={`btn btn-outline-danger mt-0 ${
                                          promo.status === "DELETED"
                                            ? "disabled"
                                            : ""
                                        }`}
                                        style={{
                                          width: "100%",
                                          pointerEvents:
                                            promo.status === "DELETED"
                                              ? "none"
                                              : "auto",
                                          opacity:
                                            promo.status === "DELETED"
                                              ? 0.5
                                              : 1,
                                        }}
                                        onClick={(e) => {
                                          if (promo.status !== "DELETED") {
                                            deleteShopPromotion(promo.id);
                                          } else {
                                            e.preventDefault();
                                          }
                                        }}
                                      >
                                        <i className="fas fa-trash"></i> Delete
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="col-12 text-center py-3">
                          <img
                            src="assets/img/data-not-found-png-yellow.jpg.png"
                            className="img-fluid rounded-start"
                            alt="No data"
                          />
                          <h4>No active promotions available.</h4>
                        </div>
                      )}

                      <div className="col-12 d-flex align-items-center justify-content-center">
                        <ul className="pagination">
                          <li
                            className={`page-item ${
                              currentPage === 1 ? "disabled" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={handleActivePreviousPage}
                            >
                              &laquo;
                            </button>
                          </li>
                          {generateActivePageNumbers().map((page) => (
                            <li
                              key={page}
                              className={`page-item ${
                                currentPage === page ? "active" : ""
                              }`}
                            >
                              <button
                                className="page-link"
                                onClick={() => setCurrentPage(page)}
                              >
                                {page}
                              </button>
                            </li>
                          ))}
                          <li
                            className={`page-item ${
                              currentPage === totalActiveElements
                                ? "disabled"
                                : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={handleActiveNextPage}
                            >
                              &raquo;
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div
                    className="tab-pane fade"
                    id="pills-expiry"
                    role="tabpanel"
                    aria-labelledby="pills-expiry-tab"
                  >
                    <div className="row row-cols-1 row-cols-md-2 gx-4">
                      {Array.isArray(expiryPromotions.data) &&
                      expiryPromotions.data.length > 0 ? (
                        expiryPromotions.data.map((promo) => (
                          <div className="col-sm-6" key={promo.id}>
                            <div className="card card-border-yellow">
                              <div className="row g-0">
                                <div
                                  className="col-md-6 d-flex align-items-center justify-content-center border-right-home"
                                  style={{
                                    maxHeight: "420px",
                                    overflow: "hidden",
                                  }}
                                >
                                  <img
                                    src={`https://d3p6cw3ny59ckg.cloudfront.net/store/${
                                      promo.image || "default.jpg"
                                    }`}
                                    alt="Promo"
                                    style={{
                                      maxWidth: "100%",
                                      maxHeight: "100%",
                                      objectFit: "contain",
                                    }}
                                  />
                                </div>
                                <div className="col-md-6">
                                  <div className="card-body overflow-auto">
                                    <p className="card-text">
                                      {promo.promotion_attributes
                                        ?.description ||
                                        "No details available."}
                                    </p>
                                  </div>
                                  <div class="col-12 p-3">
                                    <div className="mb-0">
                                      <Table class="table table-borderless mb-0">
                                        <TableBody>
                                          <TableRow>
                                            <td class="text-bold">Likes:</td>
                                            <td>{promo.likes}</td>
                                          </TableRow>
                                          <TableRow>
                                            <td class="text-bold">Views:</td>
                                            <td>{promo.views}</td>
                                          </TableRow>
                                          <TableRow>
                                            <td class="text-bold">Status:</td>
                                            <td>
                                              Expired
                                              {/* {promo.promotionStatus
                                                ? promo.promotionStatus
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                  promo.promotionStatus
                                                    .slice(1)
                                                    .toLowerCase()
                                                : "N/A"} */}
                                            </td>
                                          </TableRow>
                                        </TableBody>
                                      </Table>
                                      <Link
                                        href="#"
                                        className={`btn btn-outline-danger mt-0 ${
                                          promo.promotionStatus === "CLOSED"
                                            ? "disabled"
                                            : ""
                                        }`}
                                        style={{
                                          width: "100%",
                                          pointerEvents:
                                            promo.promotionStatus === "CLOSED"
                                              ? "none"
                                              : "auto",
                                          opacity:
                                            promo.promotionStatus === "CLOSED"
                                              ? 0.5
                                              : 1,
                                        }}
                                        onClick={(e) => {
                                          if (
                                            promo.promotionStatus !== "CLOSED"
                                          ) {
                                            deleteShopPromotion(promo.id);
                                          } else {
                                            e.preventDefault();
                                          }
                                        }}
                                      >
                                        <i className="fas fa-trash"></i> Delete
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="col-12 text-center py-3">
                          <img
                            src="assets/img/data-not-found-png-yellow.jpg.png"
                            className="img-fluid rounded-start"
                            alt="No data"
                          />
                          <h4>No deleted data available.</h4>
                        </div>
                      )}

                      {/* pagination */}
                      <div className="col-12 d-flex align-items-center justify-content-center">
                        <ul className="pagination">
                          <li
                            className={`page-item ${
                              currentPage === 1 ? "disabled" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={handleExpiryPreviousPage}
                            >
                              &laquo;
                            </button>
                          </li>
                          {generateExpiryPageNumbers().map((page) => (
                            <li
                              key={page}
                              className={`page-item ${
                                currentPage === page ? "active" : ""
                              }`}
                            >
                              <button
                                className="page-link"
                                onClick={() => setCurrentPage(page)}
                              >
                                {page}
                              </button>
                            </li>
                          ))}
                          <li
                            className={`page-item ${
                              currentPage === totalExpiryPages ? "disabled" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={handleExpiryNextPage}
                            >
                              &raquo;
                            </button>
                          </li>
                        </ul>
                      </div>
                      {/* end pagination */}
                    </div>
                  </div>

                  <div
                    class="tab-pane fade"
                    id="pills-deleted"
                    role="tabpanel"
                    aria-labelledby="pills-deleted-tab"
                  >
                    <div className="row row-cols-1 row-cols-md-2 gx-4">
                      {Array.isArray(deletedPromotions.data) &&
                      deletedPromotions.data.length > 0 ? (
                        deletedPromotions.data.map((promo) => (
                          <div className="col-sm-6" key={promo.id}>
                            <div className="card card-border-yellow">
                              <div className="row g-0">
                                <div
                                  className="col-md-6 d-flex align-items-center justify-content-center border-right-home"
                                  style={{
                                    maxHeight: "420px",
                                    overflow: "hidden",
                                  }}
                                >
                                  <img
                                    src={`https://d3p6cw3ny59ckg.cloudfront.net/store/${
                                      promo.image || "default.jpg"
                                    }`}
                                    alt="Promo"
                                    style={{
                                      maxWidth: "100%",
                                      maxHeight: "100%",
                                      objectFit: "contain",
                                    }}
                                  />
                                </div>
                                <div className="col-md-6">
                                  <div className="card-body overflow-auto">
                                    <p className="card-text">
                                      {promo.promotion_attributes
                                        ?.description ||
                                        "No details available."}
                                    </p>
                                  </div>
                                  <div class="col-12 p-3">
                                    <div className="mb-0">
                                      <Table class="table table-borderless mb-0">
                                        <TableBody>
                                          <TableRow>
                                            <td class="text-bold">Likes:</td>
                                            <td>{promo.likes}</td>
                                          </TableRow>
                                          <TableRow>
                                            <td class="text-bold">Views:</td>
                                            <td>{promo.views}</td>
                                          </TableRow>
                                          <TableRow>
                                            <td class="text-bold">Status:</td>
                                            <td>
                                              {promo.promotionStatus
                                                ? promo.promotionStatus
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                  promo.promotionStatus
                                                    .slice(1)
                                                    .toLowerCase()
                                                : "N/A"}
                                            </td>
                                          </TableRow>
                                        </TableBody>
                                      </Table>
                                      <Link
                                        href="#"
                                        className={`btn btn-outline-danger mt-0 ${
                                          promo.promotionStatus === "Deleted"
                                            ? "disabled"
                                            : ""
                                        }`}
                                        style={{
                                          width: "100%",
                                          pointerEvents:
                                            promo.promotionStatus === "Deleted"
                                              ? "none"
                                              : "auto",
                                          opacity:
                                            promo.promotionStatus === "Deleted"
                                              ? 0.5
                                              : 1,
                                        }}
                                        onClick={(e) => {
                                          if (
                                            promo.promotionStatus !== "Deleted"
                                          ) {
                                            deleteShopPromotion(promo.id);
                                          } else {
                                            e.preventDefault();
                                          }
                                        }}
                                      >
                                        <i className="fas fa-trash"></i> Delete
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="col-12 text-center py-3">
                          <img
                            src="assets/img/data-not-found-png-yellow.jpg.png"
                            className="img-fluid rounded-start"
                            alt="No data"
                          />
                          <h4>No deleted data available.</h4>
                        </div>
                      )}

                      <div className="col-12 d-flex align-items-center justify-content-center">
                        <ul className="pagination">
                          <li
                            className={`page-item ${
                              currentPage === 1 ? "disabled" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={handleDeletePreviousPage}
                            >
                              &laquo;
                            </button>
                          </li>
                          {generateDeletePageNumbers().map((page) => (
                            <li
                              key={page}
                              className={`page-item ${
                                currentPage === page ? "active" : ""
                              }`}
                            >
                              <button
                                className="page-link"
                                onClick={() => setCurrentPage(page)}
                              >
                                {page}
                              </button>
                            </li>
                          ))}
                          <li
                            className={`page-item ${
                              currentPage === totalDeleteElements
                                ? "disabled"
                                : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={handleDeleteNextPage}
                            >
                              &raquo;
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div className="col-12 d-flex align-items-center justify-content-center">
                  <ul className="pagination">
                    <li
                      className={`page-item ${
                        currentPage === 1 ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={handlePreviousPage}
                      >
                        &laquo;
                      </button>
                    </li>
                    {generatePageNumbers().map((page) => (
                      <li
                        key={page}
                        className={`page-item ${
                          currentPage === page ? "active" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => setCurrentPage(page)}
                        >
                          {page}
                        </button>
                      </li>
                    ))}
                    <li
                      className={`page-item ${
                        currentPage === totalPages ? "disabled" : ""
                      }`}
                    >
                      <button className="page-link" onClick={handleNextPage}>
                        &raquo;
                      </button>
                    </li>
                  </ul>
                </div> */}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
